<template>
  <div>
    <h3 class="mb-3">Candidate Resources</h3>
    <div class="row">
      <div v-for="file in candidateFiles" :key="file.id" class="col-lg-4">
        <div class="center py-4 mb-3" style="border: 1px solid var(--bootstrapgrey); border-radius: 3px;">
          <h5 class="mb-3">{{ file.name }}</h5>
          <a style="" :href="file.file_link" target="_blank"><button class="mylisting-button dark-button">View</button></a>
        </div>
      </div>
    </div>

    <hr>

    <h3 class="mb-3">Client Resources</h3>
    <div class="row">
      <div v-for="file in employerFiles" :key="file.id" class="col-lg-4">
        <div class="center py-4 mb-3" style="border: 1px solid var(--bootstrapgrey); border-radius: 3px;">
          <h5 class="mb-3">{{ file.name }}</h5>
          <a style="" :href="file.file_link" target="_blank"><button class="mylisting-button dark-button">View</button></a>
          <p v-if="$store.getters.isAgent === true" class="delete-text mt-2" @click="showDeleteFileModal(file)">Delete</p>
        </div>
      </div>
    </div>


    <button class="mylisting-button dark-button mt-4" @click="showUploadFileModal()">Upload File</button>

    <modal name="upload-file-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <div class="">
          <label style="">File Name</label>
          <input type="text" class="form-control mb-2" v-model="fileName">
          <input type="file" class="form-control-file mb-2" style="font-size: 0.8rem;" id="file" ref="file" v-on:change="handleFileUpload()"/>
          <div v-for="(option, index) in selectors" class="form-check pl-4" :key="'selector'+index">
            <!-- <input class="form-check-input" type="radio" name="preferredCommRadios" v-model="preferredComm"> -->
            <input class="form-check-input" type="radio" :id="'selector'+index" :value="option" v-model="selector">
            <label class="form-check-label ml-1" :for="'selector'+index">
              {{ option }}
            </label>
          </div>
        </div>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('upload-file-modal')" style="">Close</button>
        <button v-if="fileName && file && selector" class="mylisting-button dark-button" style="float: right;" @click="uploadFile()">Upload File</button>
      </div>
    </modal>

    <modal name="delete-file-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h4>Are you sure you want to remove {{ selectedFile.name }}?</h4>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('delete-file-modal')" style="">Cancel</button>
        <button class="mylisting-button danger-button" @click="deleteFile(selectedFile)" style="float: right;">Delete</button>
      </div>
    </modal>

  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      candidateFiles: [],
      employerFiles: [],
      file: '',
      fileName: '',
      selector: '',
      selectors: ['Candidate', 'Employer'],
      selectedFile: {},
    }
  },
  created() {
    this.getFiles()
  },
  methods: {
    getFiles() {
      axios.get(`/api/files/?agency=${this.$store.getters.agencyID}&selector1=Resource&selector2=Candidate`)
        .then(res => {
          this.candidateFiles = res.data
        })
        .catch(error => console.log(error))

      axios.get(`/api/files/?agency=${this.$store.getters.agencyID}&selector1=Resource&selector2=Employer`)
        .then(res => {
          this.employerFiles = res.data
        })
        .catch(error => console.log(error))
    },
    showUploadFileModal() {
      this.file = ''
      this.fileName = ''
      this.selector = ''
      this.$modal.show('upload-file-modal')
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    uploadFile() {
      axios.post(`/api/files/`, {
        // user: this.user.id,
        name: this.fileName,
        selector1: 'Resource',
        selector2: this.selector,
        agency_owner: this.$store.getters.agencyName,
        agency: this.$store.getters.agencyID,
      })
        .then(res => {
          let formData = new FormData();
          if (this.file) {
            formData.append("file_link", this.file);
          }
          axios.patch(`/api/files/${res.data.id}/`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data"
              }
            }
          )
            .then(res => {
              this.getFiles()
              this.$modal.hide('upload-file-modal')
            })
            .catch(error => console.log(error))
        })
        .catch(error => console.log(error))
    },
    showDeleteFileModal(file) {
      this.selectedFile = file
      this.$modal.show('delete-file-modal')
    },
    deleteFile(file) {
      axios.delete(`/api/files/${file.id}`)
        .then(res => {
          this.$modal.hide('delete-file-modal')
          this.getFiles()
        })
        .catch(error => console.log(error))
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/agents/systems/ResourceManager.vue